import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StatsCard = ({ 
  title, 
  value, 
  change, 
  status,
  trend,
  changeType = 'neutral', 
  icon: Icon, 
  color = 'primary',
  loading = false,
  compact = false 
  ,
  // optional previous value to show in tooltip (no longer used, but kept in props for compatibility if needed)
  prevValue
}) => {
  const getColorClasses = (color) => {
    const colorMap = {
      primary: 'text-primary-600 bg-primary-50',
      success: 'text-success-600 bg-success-50',
      warning: 'text-warning-600 bg-warning-50',
      danger: 'text-danger-600 bg-danger-50',
      info: 'text-blue-600 bg-blue-50'
    };
    return colorMap[color] || colorMap.primary;
  };

  // Universal icon renderer based on trend and changeType
  const getChangeIcon = (trend, changeType) => {
    if (trend === "up") {
      return (
        <TrendingUp
          className={`h-4 w-4 ${
            changeType === "positive" ? "text-green-600" : "text-red-600"
          }`}
        />
      );
    }

    if (trend === "down") {
      return (
        <TrendingDown
          className={`h-4 w-4 ${
            changeType === "positive" ? "text-green-600" : "text-red-600"
          }`}
        />
      );
    }

    return null;
  };

  if (loading) {
    return (
      <div className={`stats-card ${compact ? 'p-4' : 'p-6'}`}>
        <div className="animate-pulse">
          <div className="flex items-center justify-between mb-4">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="h-8 w-8 bg-gray-200 rounded"></div>
          </div>
          <div className="h-8 bg-gray-200 rounded w-20 mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-16"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`stats-card relative ${compact ? 'p-4' : 'p-6'}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="stats-card-label">{title}</h3>
        <div className={`p-2 rounded-lg ${getColorClasses(color)}`}>
          <Icon className="h-6 w-6" />
        </div>
      </div>
      
      <div className="stats-card-value mb-2">
        {typeof value === 'number' ? value.toLocaleString() : value}
      </div>
      
      {change && (
        <div
          className={`stats-card-change flex items-center space-x-1 ${
            changeType === "positive"
              ? "text-green-600"
              : changeType === "negative"
              ? "text-red-600"
              : "text-gray-400"
          }`}>
          {getChangeIcon(trend, changeType)}
          <span className="text-sm font-medium">{change}</span>
        </div>
      )}
    </div>
  );
};

export default StatsCard; 